import { ButtonLink } from '@/components/ui/Button'
import { useTranslator } from '@/hooks/useTranslator'
import { getArea } from '@/stores/areas'
import { useSelector } from '@/stores/hooks'
import { getStop } from '@/stores/stops'
import { type PopupInfo } from '@/stores/temp'
import { modeTheme } from '@/theme'
import { determineTypeStop } from '@/util/journeys'
import { classes } from '@lc/libreact'
import styles from './PopupButtonSchedules.scss'

export function PopupButtonSchedules({ id, type }: PopupInfo) {
	const translator = useTranslator()
	const stop = useSelector(state => {
		if (type === 'stop_point') return getStop(state, id)
		if (type === 'stop_area') return getArea(state, id)
		return null
	})

	if (!stop || stop.geojson?.type !== 'Point') return null

	let url: string
	const searchParams = new URLSearchParams()
	const isStop = determineTypeStop(stop)
	const isStopWithOneRoute = stop.lines?.length === 1

	if (!isStopWithOneRoute) {
		const area = (isStop && stop.stopArea) || stop.id
		searchParams.set('area', area)
		searchParams.set('name', stop.name)
		url = `/public-transport/lines?${searchParams.toString()}`
	} else {
		url = `/public-transport/lines/${stop.lines?.[0]}/forward/${stop.id}`
	}

	return (
		<ButtonLink
			size="small"
			level="popup"
			border
			href={url}
			label={translator.translate('stop:schedules')}
			iconUrl="assets/Timer.svg"
			className={classes(styles.button, modeTheme('public-transport'))}
		/>
	)
}
